export enum BOOKING_MEETING_ROOM {
    DRAFT = 'DRAFT', // บันทึกร่าง   กดบันทึกร่าง
    // UNDER_CONSIDERATION = 'UNDER_CONSIDERATION', // อยู่ระหว่างพิจารณา
    WAITING_TO_CONSIDER = 'WAITING_TO_CONSIDER', // รอพิจารณา  กดบันทึก
    CONFIRM_BOOKING = 'CONFIRM_BOOKING', //อนุมัติการจอง
    REJECT_BOOKING = 'REJECT_BOOKING', //ไม่อนุมัติการจอง
    WAITING_PAYMENT = 'WAITING_PAYMENT', // รอชำระเงิน
    WAITING_CONFIRM_PAYMENT = 'WAITING_CONFIRM_PAYMENT', //รอตรวจสอบการชำระเงิน
    RECHECK_PAYMENT = 'RECHECK_PAYMENT' //ส่งทบทวนชำระเงิน
}

export const booking_meeting_room_status = [
    { value: BOOKING_MEETING_ROOM.DRAFT, label: 'บันทึกร่าง' },
    // { value: BOOKING_MEETING_ROOM.UNDER_CONSIDERATION, label: 'อยู่ระหว่างพิจารณา' },
    { value: BOOKING_MEETING_ROOM.WAITING_TO_CONSIDER, label: 'รอพิจารณา' },
    { value: BOOKING_MEETING_ROOM.CONFIRM_BOOKING, label: 'อนุมัติการจอง' },
    { value: BOOKING_MEETING_ROOM.REJECT_BOOKING, label: 'ไม่อนุมัติการจอง' },
    { value: BOOKING_MEETING_ROOM.WAITING_PAYMENT, label: 'รอชำระเงิน' },
    { value: BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT, label: 'รอตรวจสอบการชำระเงิน' },
    { value: BOOKING_MEETING_ROOM.RECHECK_PAYMENT, label: 'ส่งทบทวนชำระเงิน' },
];
export enum BOOKING_MEETING_APPROVE {
    APPROVE = 'APPROVE',
    REJECT = 'REJECT',
    WAITING = 'WAITING',
}

export enum CURRENCY {
    THB = "THB",
    USD = "USD"
}
export const currency_options = [
    { label: "THB", value: CURRENCY.THB },
    { label: "USD", value: CURRENCY.USD }
];